import { render } from "./AboutValues.vue?vue&type=template&id=77c8a862"
import script from "./AboutValues.vue?vue&type=script&lang=js"
export * from "./AboutValues.vue?vue&type=script&lang=js"

import "./AboutValues.vue?vue&type=style&index=0&id=77c8a862&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__